

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const REJECTREVIEWEREVALUATION= createAsyncThunk(
  "rejectReviewerEvaluation/rejectReviewerEvaluation",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const rejectReviewerEvaluationSlice = createSlice({
  name: "rejectReviewerEvaluationSlice",
  initialState: {
    rejectReviewerEvaluation: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfrejectReviewerEvaluation: (state) => {
        state.rejectReviewerEvaluation.loading = false
        state.rejectReviewerEvaluation.error = false
        state.rejectReviewerEvaluation.data = []
        state.rejectReviewerEvaluation.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(REJECTREVIEWEREVALUATION.fulfilled, (state, action) => {
      state.rejectReviewerEvaluation = {
        ...state.rejectReviewerEvaluation,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REJECTREVIEWEREVALUATION.pending, (state, action) => {
      state.rejectReviewerEvaluation = {
        ...state.rejectReviewerEvaluation,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REJECTREVIEWEREVALUATION.rejected, (state, action) => {
      state.rejectReviewerEvaluation = {
        ...state.rejectReviewerEvaluation,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const rejectReviewerEvaluationAction = {
    REJECTREVIEWEREVALUATION,
};

export { rejectReviewerEvaluationAction };
export default rejectReviewerEvaluationSlice.reducer;
export const {setInitialStateOfrejectReviewerEvaluation} = rejectReviewerEvaluationSlice.actions
